export default __webpack_public_path__ + "static/media/students.2a4c6fc1.svg";